import './App.css';

import Calculator from 'components/Calculator/Calculator';

function App() {
  return (
    <div className="App calculator">
      <header>Calculator</header>
      <Calculator />
    </div>
  );
}

export default App;
